var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dot = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _times = _interopRequireDefault(require("lodash/times"));

var _styledSystem = require("@sport1/styled-system");

var _Basic = require("../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Pagination/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Pagination = function (_React$Component) {
  (0, _inherits2.default)(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Pagination);
    _this = _super.call(this, props);

    _this.onRenderDot = function (dotIndex) {
      var allDotsHaveRendered = !_this.state.allDotsHaveRendered && dotIndex === _this.props.itemCount - 1;

      if (allDotsHaveRendered) {
        _this.setState({
          allDotsHaveRendered: true
        });
      }
    };

    _this.getMaxDotCount = function () {
      return _this.props.itemCount > _this.props.maxDotCount ? _this.props.maxDotCount : _this.props.itemCount;
    };

    _this.getDotSize = function (index) {
      if (_this.props.itemCount <= _this.props.maxDotCount) {
        return _this.state.bigDotSize;
      }

      if (_this.state.scrollPositionX === 0) {
        if (index < 4) {
          return _this.state.bigDotSize;
        }
      } else if (_this.state.scrollPositionX >= _this.maxScrollX()) {
        if (index > _this.props.itemCount - 5) {
          return _this.state.bigDotSize;
        }
      } else if (index > _this.state.currentIndex - 2 && index < _this.state.currentIndex + 2) {
        return _this.state.bigDotSize;
      }

      return _this.state.smallDotSize;
    };

    _this.maxScrollX = function () {
      return _this.props.itemCount - _this.props.maxDotCount > 0 && (_this.props.itemCount - _this.props.maxDotCount) * _this.state.dotContainerSize;
    };

    _this.calcLeftMargin = function () {
      if (_this.state.currentIndex < Math.round(_this.getMaxDotCount() / 2)) {
        return 0;
      }

      if (_this.state.currentIndex > _this.props.itemCount - Math.round(_this.getMaxDotCount() / 2) - 1) {
        return (_this.props.itemCount - _this.getMaxDotCount()) * _this.state.dotContainerSize * -1;
      }

      return (_this.state.currentIndex - Math.floor(_this.getMaxDotCount() / 2)) * -1 * _this.state.dotContainerSize;
    };

    _this.captureRef = function (ref) {
      _this._scrollView = ref;
    };

    _this.state = {
      currentIndex: props.startIndex || 0,
      scrollPositionX: 0,
      bigDotSize: 6,
      smallDotSize: 4,
      dotContainerSize: 6 + (0, _styledSystem.themeGet)('space.1', 4)(_this.props) * 2,
      allDotsHaveRendered: false
    };
    return _this;
  }

  (0, _createClass2.default)(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          itemCount = _this$props.itemCount,
          activeDotColor = _this$props.activeDotColor,
          inactiveDotColor = _this$props.inactiveDotColor,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["itemCount", "activeDotColor", "inactiveDotColor"]);
      return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        center: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.View, {
        width: this.state.dotContainerSize * this.getMaxDotCount(),
        overflow: "hidden",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 109,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Row, {
        innerRef: this.captureRef(),
        ml: this.calcLeftMargin(),
        style: {
          transition: 'margin-left ease-out 0.45s'
        },
        bg: "transparent",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 21
        }
      }, (0, _times.default)(itemCount, function (i) {
        return _react.default.createElement(_Basic.Row, {
          center: true,
          key: i,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 119,
            columnNumber: 29
          }
        }, _react.default.createElement(_Basic.View, {
          width: _this2.state.bigDotSize,
          height: _this2.state.bigDotSize,
          mx: 1,
          center: true,
          isFlex: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120,
            columnNumber: 33
          }
        }, _react.default.createElement(Dot, {
          size: _this2.getDotSize(i),
          isActive: i === _this2.state.currentIndex,
          onLayout: _this2.onRenderDot(i),
          activeDotColor: activeDotColor || 'background.alternate',
          inactiveDotColor: inactiveDotColor || 'border.main',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 127,
            columnNumber: 37
          }
        })));
      }))));
    }
  }]);
  return Pagination;
}(_react.default.Component);

Pagination.propTypes = {
  itemCount: _propTypes.default.number.isRequired,
  maxDotCount: _propTypes.default.number,
  startIndex: _propTypes.default.number,
  currentIndex: _propTypes.default.number
};
Pagination.defaultProps = {
  maxDotCount: 5,
  startIndex: 0
};

Pagination.getDerivedStateFromProps = function (nextProps, prevState) {
  var scrollToX = 0;

  if (nextProps.itemCount > nextProps.maxDotCount) {
    scrollToX = (nextProps.currentIndex - 2) * prevState.dotContainerSize;
    if (scrollToX < 0) scrollToX = 0;
  }

  return {
    currentIndex: nextProps.currentIndex,
    scrollPositionX: scrollToX
  };
};

var _default = Pagination;
exports.default = _default;

var Dot = function Dot(_ref) {
  var size = _ref.size,
      isActive = _ref.isActive,
      onLayout = _ref.onLayout,
      activeDotColor = _ref.activeDotColor,
      inactiveDotColor = _ref.inactiveDotColor,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["size", "isActive", "onLayout", "activeDotColor", "inactiveDotColor"]);
  return _react.default.createElement(_Basic.View, (0, _extends2.default)({
    height: size,
    width: size,
    bg: isActive ? activeDotColor : inactiveDotColor,
    borderRadius: size / 2,
    onLayout: onLayout
  }, _objectSpread({}, rest), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 5
    }
  }));
};

exports.Dot = Dot;